import { Component, Input } from "@angular/core";
import { LovedOneCareNeedsAssessmentModel, NeedsAndLevelOfAutonomyModel } from "@nx-c4g/c4g-models";

@Component({
  selector: 'c4g-lo-need',
  templateUrl: './lo-need.component.html',
  styleUrls: ['./lo-need.component.scss'],
})
export class LoNeedComponent  {
  @Input() aboutThePatient: string;
  @Input() needsOfThePatient: string;
}
